import { ACTIONS_TYPES } from 'app/automations/automation-helpers-actions';
import { CustomModelAction, CustomModelProperty } from 'app/automations/automations-models';

const URL_PATTERN = /^https?:\/\/\S+$/i;

function isMalformedUrl(prop: CustomModelProperty): boolean {
  const isUrlProp = (prop as { isUrl?: boolean })?.isUrl === true || prop?.name === 'url';
  return isUrlProp && !!prop?.value && !URL_PATTERN.test(String(prop.value));
}

function isMalformedLanguage(action: CustomModelAction, prop: CustomModelProperty): boolean {
  if (prop?.name !== 'language' || !prop.value || action?.$type === ACTIONS_TYPES.VoyadoRegisterCart) {
    return false;
  }
  const value = String(prop.value);
  return value.length > 2 || value.length === 1 || /[A-Z]/.test(value);
}

// The per-action editor shows an inline error for a bad URL/language but doesn't block Save; the parent
// re-checks so it can.
export function actionHasInvalidFormatProp(action: CustomModelAction): boolean {
  return (action?.properties ?? []).some((prop) => isMalformedUrl(prop) || isMalformedLanguage(action, prop));
}
